<template>
  <!-- The item's history in the shared activity log design (US 9438) -->
  <div class="v2-card af-card" data-qid="history-tab">
    <ActivityFeed :log="object.who_am_i + '::' + object.id"
                  :here="object"
                  action-filter
                  person-filter/>
  </div>
</template>

<script>
  import ActivityFeed from '@/components/activity/feed/ActivityFeed.vue';

  export default {
    name: 'ProcessHistory',
    components: {
      ActivityFeed
    },
    props: {
      object: {
        type: Object,
        required: true
      }
    }
  }
</script>
